<router-outlet></router-outlet>
<ngx-ui-loader></ngx-ui-loader>